var map = {
	"./vilaflor/default-logo.png": 87880,
	"./vilaflor/favicon.png": 86061,
	"./vilaflor/footer-logo.png": 41334,
	"./vilaflor/logo-1.svg": 40845,
	"./vilaflor/logo-2.svg": 30126,
	"./vilaflor/logo-3.svg": 68063,
	"./vilaflor/logo-header-mobile.svg": 71786,
	"./vilaflor/logo-header-tablet.svg": 1620,
	"./vilaflor/logo-header.svg": 61195,
	"./vilaflor/logo-mobile.svg": 69098,
	"./vilaflor/logo.svg": 17003,
	"./vilaflor/maskable-icon.png": 60359
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38618;